import React, {Fragment} from "react";
import moment from 'moment';
import classNames from 'classnames';
import {FullCalendar} from 'primereact/fullcalendar';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import allLocales from '@fullcalendar/core/locales-all';

import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';
import '@fullcalendar/timegrid/main.css';
import {SplitButton} from "primereact/splitbutton";
import isEqual from "lodash-es/isEqual";

export default class SelectorCalendar extends React.Component {

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!isEqual(prevProps.value, this.props.value)) {
            this.fullcalendar && this.fullcalendar.calendar.refetchEvents();
        }
    }

    static formatRows = (rows) => {
        return rows.map((item) => {
            item.title = item.program.name + " - " + (item.locations || []).map((location) => location.name).join(", ");
            item.start = moment(item.from, "YYYY-MM-DD HH:mm:ss").toDate();
            item.end = moment(item.to, "YYYY-MM-DD HH:mm:ss").toDate();
            return item;
        });
    }

    events = (info/*, successCallback, failureCallback*/) => {
        return new Promise((resolve, reject) => {
            const p = this.props.onPage(info);
            p.then((state) => {
                if (!state.loading) {
                    resolve(state.data.rows);
                }
            });
        });
    }

    render() {
        return (
            <div className="fc-holder">
                {this.props.exportModel.length ? <SplitButton
                    disabled={this.props.loading}
                    {...this.props.exportModel[0]}
                    onClick={this.props.exportModel[0].command}
                    model={this.props.exportModel}
                    className="p-button-secondary pull-left export-btn"
                /> : null}
                <FullCalendar
                    ref={(fullcalendar) => {
                        this.fullcalendar = fullcalendar;
                    }}
                    events={this.events}
                    options={{
                        locales: allLocales,
                        locale: 'hu',
                        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
                        defaultView: 'timeGridWeek', // dayGridMonth
                        defaultDate: moment().toDate(),
                        header: {
                            left: 'prev,next',
                            center: 'title',
                            right: 'dayGridMonth,timeGridWeek,timeGridDay'
                        },
                        editable: true,
                        eventRender: (info) => {
                            if (this.props.rowClassName) {
                                info.el.className = info.el.className + " " + classNames(this.props.rowClassName(info.event.extendedProps));
                            }
                        },
                        eventClick: (info) => this.props.onSelectionChange({value: info.event})
                    }}
                />
            </div>
        );
    }
}